import React, { useEffect } from 'react';
import { useIntl } from 'react-intl-next';
import { useSnapshot } from 'valtio';

import { currentConnectionStatus } from '@canvas/canvas-state';

import { messages } from '../src/i18n';

import { useContentStatusHeader } from './header/useContentStatusHeader';
import { useContentVersionHeader } from './header/useContentVersionHeader';

export const ContentStatusObserver: React.FC<{
  updateContentStatus?: ({
    status,
    tooltipText,
  }: {
    status: string;
    tooltipText: string | undefined;
  }) => void;
  contentId: string;
  versionName: string | undefined;
}> = ({ updateContentStatus, contentId, versionName }) => {
  const { formatMessage } = useIntl();

  const snackbarMessages = {
    online: formatMessage(messages['snackbar-message.online']),
    offline: formatMessage(messages['snackbar-message.offline']),
    readOnlyModeActive: formatMessage(messages['snackbar-message.readOnlyModeActive']),
    viewToEditAccess: formatMessage(messages['snackbar-message.viewToEditAccess']),
    editToViewAccess: formatMessage(messages['snackbar-message.editToViewAccess']),
    editToViewOfflineChangesDiscarded: formatMessage(
      messages['snackbar-message.editToViewOfflineChangesDiscarded']
    ),
  };

  const contentStatus = useContentStatusHeader(contentId, snackbarMessages);
  const { boardSyncStatus: contentSyncStatus } = useSnapshot(currentConnectionStatus);

  useContentVersionHeader(versionName);

  useEffect(() => {
    if (contentStatus && updateContentStatus) {
      updateContentStatus({
        status: contentStatus.status,
        tooltipText: contentStatus.tooltip,
      });
    }
  }, [contentStatus, updateContentStatus, contentSyncStatus]);

  return null;
};
